import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getIOAssociations = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/history/associations`, { params });
	return data;
};

export const confirmIOAssociation = async (payload) => {
	const { data } = await axios.post(`${API_GO}/app/history/associations/confirm`, payload);
	return data;
};
